import { Component } from "@angular/core";

@Component({
	selector: "caass-Visitor",
	templateUrl: "./visitor-multistation.component.html",
})
export class VisitorMultiStationComponent {}
